import { render, staticRenderFns } from "./addgroupeople.vue?vue&type=template&id=5ca567a4&scoped=true&"
import script from "./addgroupeople.vue?vue&type=script&lang=js&"
export * from "./addgroupeople.vue?vue&type=script&lang=js&"
import style0 from "./addgroupeople.vue?vue&type=style&index=0&id=5ca567a4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca567a4",
  null
  
)

export default component.exports